import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { TipStepInterface } from "../../store/mine_craft/tipStepsSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    image_url: minecraftUrls.remoteUrl(value.image_url),
  };
}

const tipStepsEntity = new schema.Entity(
  'tip_steps',
  {},
  {
    processStrategy
  }
);

const tipStepEntity = new schema.Entity(
  'tip_step',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { tip_step: TipStepInterface }>(response.data.tip_step, tipStepEntity);
  return normalized.entities;
}

export const fetchTipSteps = createAsyncThunk(
  'tipSteps/fetchTipSteps',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get(`/onesky/tip_steps`, { params })
    const normalized  = normalize<any, { tip_steps: { [key: string]: TipStepInterface } }>(response.data.tip_steps, [tipStepsEntity]);

    return {
      tip_steps: normalized.entities?.tip_steps || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchTipStep = createAsyncThunk(
  'tipSteps/fetchTipStep',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/tip_steps/${id}`);
    return normalizeInstance(response);
  }
);

export const createTipStep = createAsyncThunk(
  'tipSteps/createTipStep',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/tip_steps`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateTipStep = createAsyncThunk(
  'tipSteps/updateTipStep',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/tip_steps/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyTipStep = createAsyncThunk(
  'tipSteps/destroyTipStep',
  async (id: number) => {
    await mineCraftApi.delete(`/onesky/tip_steps/${id}`);
    return { id: id };
  }
);

export const reorderTipSteps = createAsyncThunk(
  'tipSteps/reorderTipSteps',
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await mineCraftApi.patch('/onesky/tip_steps/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
